window.Vue = require("vue");
window.VueEvent = new class {
    constructor() {
        this.vue = new Vue();
    }

    fire(event, data = null) {
        this.vue.$emit(event, data);
    }

    listen(event, callback) {
        this.vue.$on(event, callback);
    }
}
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
Vue.component("sweet-modal", require("./vue-components/SweetModalExtend").default);
Vue.component('SweetModalTab', SweetModalTab);
Vue.component('CenseoForm', require("./vue-components/CenseoForm").default);
Vue.component('MainMenu', require("./vue-components/MainMenu").default);
Vue.component('SubMenu', require("./vue-components/partials/SubMenu").default);
Vue.component('MenuItem', require("./vue-components/partials/MenuItem").default);
Vue.component('SearchMenu', require("./vue-components/SearchMenu").default);

let hflApp = new Vue({
    el: "#hfl-app",
    data: {
        loading: true,
        mapLoaded: false,
        streetViewLoaded: false,
        sendingForm: false,
    },
    mounted() {
        this.openResponseModal();
        VueEvent.listen('tabChanged', this.tabChanged);
    },
    methods: {
        openModalMap: function(ref,tab){
            this.$nextTick(() => {
                return this.$refs[ref].open(tab);
            });
        },
        openImagesModal: function() {
            this.$nextTick(() => {
                this.$refs['imagesModal'].open();
                this.triggerResize();
            });
            setTimeout(() => { //Ensure first image shows on slider in modal
                this.triggerResize();
            }, 500);
        },
        triggerResize: function() {
            window.dispatchEvent(new Event('resize'));
        },
        tabChanged: function(tab) {
            if(tab.id == 'street-view'){
                return this.initStreetViewModal();
            }
            if(tab.id == 'map-view'){
                return this.initGoogleMap();
            }
        },
        isNarrowScreen: function() {
            return screen.width <= 600;
        },

        initGoogleMap: function() {
            if(this.mapLoaded === false) {
                var lat = this.$refs.mapModal.$el.dataset.lat;
                var lng = this.$refs.mapModal.$el.dataset.lng;

                var googleMapContainer = document.getElementById('modal-map-container');
                var latlng = new google.maps.LatLng(lat, lng);
                var mapOptions = {
                    zoom: 16,
                    center: latlng,
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: true,
                    fullscreenControlOptions: {
                        position: google.maps.ControlPosition.BOTTOM_LEFT
                    }
                };
                window.map = new google.maps.Map(googleMapContainer, mapOptions);
                var marker = new google.maps.Marker({
                    position : latlng,
                    map: map
                });
                this.mapLoaded = true;
            }
        },

        initStreetViewModal: function() {
            if(this.streetViewLoaded === false) {
                var lat = this.$refs.mapModal.$el.dataset.lat;
                var lng = this.$refs.mapModal.$el.dataset.lng;

                var streetViewContainer = document.getElementById('modal-street-view-container');
                var latlng = new google.maps.LatLng(lat, lng);
                var streetViewMapOptions = {
                    zoom: 16,
                    center: latlng,
                }
                var streetViewOptions = {
                    position: latlng,
                    visible: true,
                    pov: {
                      heading: 0,
                      pitch: 10
                    }
                }
                var streetViewMap = new google.maps.Map(streetViewContainer, streetViewMapOptions);
                var streetView = new google.maps.StreetViewPanorama(streetViewContainer, streetViewOptions);
                streetViewMap.setStreetView(streetView);
                this.streetViewLoaded = true;
            }
        },
        openPlotDescriptionModal: function(containerId) {
            var wrap = document.getElementById('plot-full-specification');
            wrap.innerHTML = document.getElementById(containerId).value;
            if (listingSpecs.length) {
                wrap.innerHTML = '';
                listingSpecs.forEach(spec => {
                    let content = '<div class="specification">';
                    content +=   '<h4 class="spec-name mt-2">' + spec.name + '</h4>';
                    if (spec.imageUrl && spec.imageUrl !== '') {
                        content +=  '<div class="spec-image">';
                        content +=   '<img class="w-100 mb-2" style="border: 5px solid white; border-radius: 6px; box-shadow: 0 0 10px #0003" src="' + spec.imageUrl + '" />';
                        content +=  '</div>'
                    }
                    content +=   '<p class="spec-desc">' + spec.description + '</p>';
                    content += '</div>';
                    wrap.innerHTML += content;
                })
            }
            if( this.$refs.plotDescriptionModal ){
                return this.$refs.plotDescriptionModal.open();
            }
        },
        openResponseModal: function(){
            if( this.$refs.responseModal ){
                this.$refs.responseModal.open();
            }
        },
        openVideoModal: function(url, embedCode) {
            var iframeDiv = document.getElementById('embed_iframe');
            iframeDiv.innerHTML = '';
            var iframe = embedCode;
            if (!iframe) {
              iframe = '<iframe src="' + url + '" id="iframe" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
            }
            var e = document.createElement('div');
            e.innerHTML = iframe;
            iframeDiv.appendChild(e.firstChild);
            if( this.$refs.videoModal ){
                this.$refs.videoModal.open();
            }
        },
        closeVideoModal: function() {
            var iframeDiv = document.getElementById('embed_iframe');
            iframeDiv.innerHTML = '';
        },
        openCookieControl: function() {
            CookieControl.open();
        }
    }
});

require('./bootstrap');
require('./general');

//Show/hide auth modals

document.addEventListener('DOMContentLoaded', () => {
    let buttons = document.querySelectorAll('.auth-button');
    buttons.forEach((button) => {
        button.addEventListener('click', (event) => {
            event.preventDefault();
            document.querySelectorAll('.auth-modal').forEach((modal) => modal.classList.remove('open'));
            const modal = button.getAttribute('modal');
            document.querySelector('.auth-modal-' + modal).classList.add('open');
        })
    });
    let closes = document.querySelectorAll('.modal-close');
    closes.forEach((btn) => {
        btn.addEventListener('click', () => {
            document.querySelectorAll('.auth-modal').forEach((modal) => modal.classList.remove('open'));
        })
    });
})
